/**
 * @file: 渲染碗碟架位置、大小
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import FrontCubeData from '../../../frontCubeData/index';
import Config from '../../../config/index';

const defaultWidth: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultWidth'
});
const defaultModuleHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultModuleHeight'
});

// 渲染碗碟架定位和宽高
export function renderDishrackPosition(cube: FreeObjMap): void {
    let parentCubeId: string = CubeTree.findParentIdByCubeId(cube.id);
    let moduleWidth: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleWidth');
    let moduleHeight: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleHeight');
    let bottom: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'posY');
    let left: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'posX');
    let backgroundColor: string = FrontCubeData.getValue(cube.id, 'moduleColor') || '';

    // 立式货架层板
    if (CubeTree.isShelf(parentCubeId) && moduleWidth <= 0) {
        moduleWidth = FrontCubeData.getLogicValue(parentCubeId, 'width');
    }

    if (CubeTree.isSketchpad(parentCubeId) && moduleWidth <= 0) {
        moduleWidth = Toolkit.cmToPx(defaultWidth);
    }

    if (moduleHeight <= 0) {
        moduleHeight = Toolkit.cmToPx(defaultModuleHeight);
    }

    cube.jView.css({
        top: '',
        bottom: bottom,
        left: left,
        position: 'absolute',
        height: moduleHeight,
        width: moduleWidth,
        backgroundColor: backgroundColor
    });

    //层板厚度区域
    cube.jView.find('.J_PartitionDishrackBone').css({
        width: moduleWidth,
        height: moduleHeight,
        left: '',
        top: '',
        backgroundColor: backgroundColor
    });
}
